import React from 'react';
import tw from 'twin.macro';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { PortableText } from '../elements';

const Section = styled.div`
  p,
  h1,
  h2,
  h3,
  h4 {
    ${tw`text-white m-0`}
  }
`;

const Announcement = ({ title, linkTo }) => {
  return (
    <Section tw="bg-[#55545a]">
      <div tw="!text-white container m-auto text-center p-4">
        <Link to={linkTo || '/'}>
          <PortableText tw="m-0 !text-white">{title}</PortableText>
        </Link>
      </div>
    </Section>
  );
};

export default Announcement;
